module.exports = __webpack_public_path__ + "media/images/emblems/Lutzenbe-629c03bfa6252a4a966325b655811bff.png";